import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { INavigationBarItem } from '@shared/shared/shared.module';
import { AuthService } from '@app-core/services/auth/auth.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/store/app.reducers';
import { NavigationEnd, Router } from '@angular/router';
import { UIActions } from 'src/app/core/store/actions/ui/actions';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit {
  @Input() items: INavigationBarItem[];
  @Input() logo: string;
  @Input() avatar: string;
  @Input() color: string;
  @Input() isMobile: boolean;
  @Input() position: 'top' | 'bottom';

  isEmployeesProfileRoute: boolean;
  public mobileMainItems: INavigationBarItem[];
  public mobileRemainingItems: INavigationBarItem[];
  public desktopLastItem: INavigationBarItem;
  public defaultColor = '#4b2cdc';
  public access;
  public isCustomer;
  public isCandidate;
  public permissions = [];

  @Output()
  propagar = new EventEmitter<string>();

  constructor(
    private store: Store<AppState>,
    private readonly location: Location,
    private service: AuthService,
    private router: Router
  ) {
    this.permissions = JSON.parse(localStorage.getItem('permissions'));
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const splitRoute = event.url.split('/');
        this.isEmployeesProfileRoute =
          splitRoute.includes('employees') && splitRoute.includes('profile');
      }
    });
  }

  ngOnInit() {
    if (this.isMobile) {
      this.mobileMainItems = this.items.slice(0, 3);
      this.mobileRemainingItems = this.items.slice(3);
    } else {
      this.desktopLastItem = this.items.slice(-1)[0];
    }
    this.access = this.permissions.includes('Admin');
  }

  public goBack(): void {
    this.location.back();
  }

  public logout(): void {
    this.service.logout();
  }

  selectApp(): void {
    this.service.goToApp();
  }

  toggleSideNav() {
    this.store.dispatch({ type: UIActions.UI_SIDEBAR_TOOGLE });
  }
}
